"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContribServices = exports.getPlayerContribRegistry = void 0;
var player_contrib_registry_1 = require("./player-contrib-registry");
var preset_manager_1 = require("./preset-manager");
var toast_manager_1 = require("./toast-manager");
var floating_manager_1 = require("./floating-manager");
var banner_manager_1 = require("./banner-manager");
function getPlayerContribRegistry(kalturaPlayer) {
    return player_contrib_registry_1.PlayerContribRegistry.get(kalturaPlayer);
}
exports.getPlayerContribRegistry = getPlayerContribRegistry;
var ContribServices = /** @class */ (function () {
    function ContribServices(_playerContribRegistry, _options) {
        var _this = this;
        this._playerContribRegistry = _playerContribRegistry;
        this._options = _options;
        this._registered = false;
        this._addListeners = function () {
            var kalturaPlayer = _this._options.kalturaPlayer;
            kalturaPlayer.addEventListener(kalturaPlayer.Event.PLAYER_RESET, _this.reset);
            kalturaPlayer.addEventListener(kalturaPlayer.Event.PLAYER_DESTROY, _this._removeListeners);
        };
        this._removeListeners = function () {
            var kalturaPlayer = _this._options.kalturaPlayer;
            kalturaPlayer.removeEventListener(kalturaPlayer.Event.PLAYER_RESET, _this.reset);
            kalturaPlayer.removeEventListener(kalturaPlayer.Event.PLAYER_DESTROY, _this._removeListeners);
        };
        this.register = function () {
            if (_this._registered) {
                return [];
            }
            _this._registered = true;
            return _this._presetManager.registerComponents();
        };
        this.reset = function () {
            _this._toastManager.reset();
            _this._floatingManager.reset();
            _this._bannerManager.reset();
        };
        this.destroy = function () {
            _this._registered = false;
        };
        var kalturaPlayer = this._options.kalturaPlayer;
        var presetManager = new preset_manager_1.PresetManager({
            kalturaPlayer: kalturaPlayer
        });
        var floatingManager = new floating_manager_1.FloatingManager({
            kalturaPlayer: kalturaPlayer,
            presetManager: presetManager
        });
        var toastManager = new toast_manager_1.ToastManager({
            floatingManager: floatingManager
        });
        var bannerManager = new banner_manager_1.BannerManager({
            kalturaPlayer: kalturaPlayer,
            floatingManager: floatingManager
        });
        this._toastManager = toastManager;
        this._floatingManager = floatingManager;
        this._presetManager = presetManager;
        this._bannerManager = bannerManager;
        this._addListeners();
    }
    ContribServices.get = function (options) {
        var playerContribRegistry = getPlayerContribRegistry(options.kalturaPlayer);
        return playerContribRegistry.register('ContribServices', function () {
            return new ContribServices(playerContribRegistry, options);
        });
    };
    Object.defineProperty(ContribServices.prototype, "presetManager", {
        get: function () {
            return this._presetManager;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContribServices.prototype, "floatingManager", {
        get: function () {
            return this._floatingManager;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContribServices.prototype, "toastManager", {
        get: function () {
            return this._toastManager;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContribServices.prototype, "bannerManager", {
        get: function () {
            return this._bannerManager;
        },
        enumerable: false,
        configurable: true
    });
    return ContribServices;
}());
exports.ContribServices = ContribServices;
//# sourceMappingURL=contrib-services.js.map